export default "__VITE_ASSET__DSKrXwru__"